"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    erSkuddAar: function() {
        return erSkuddAar;
    },
    maxDagerIAar: function() {
        return maxDagerIAar;
    },
    isUndefined: function() {
        return isUndefined;
    },
    isNull: function() {
        return isNull;
    },
    greaterOrEqualTo: function() {
        return greaterOrEqualTo;
    },
    lessOrEqualTo: function() {
        return lessOrEqualTo;
    },
    firstTrue: function() {
        return firstTrue;
    },
    regex: function() {
        return regex;
    },
    undefinedOrRegex: function() {
        return undefinedOrRegex;
    },
    erHeltall: function() {
        return erHeltall;
    },
    erPositivtHeltall: function() {
        return erPositivtHeltall;
    },
    isIkkePositivtHeltall: function() {
        return isIkkePositivtHeltall;
    },
    erNumerisk: function() {
        return erNumerisk;
    },
    erNumeriskNull: function() {
        return erNumeriskNull;
    },
    between: function() {
        return between;
    },
    isNumber: function() {
        return isNumber;
    },
    greaterThanAndLessOrEqual: function() {
        return greaterThanAndLessOrEqual;
    },
    empty: function() {
        return empty;
    },
    validerFnr: function() {
        return validerFnr;
    },
    validerOrgnr: function() {
        return validerOrgnr;
    },
    validerMinMaksBeloep: function() {
        return validerMinMaksBeloep;
    },
    validerValidatorkonfig: function() {
        return validerValidatorkonfig;
    },
    minErStoerreEnnMaks: function() {
        return minErStoerreEnnMaks;
    },
    TILLEGGSEIENDOM: function() {
        return TILLEGGSEIENDOM;
    },
    tilleggseiendomUtenFormuesobjekt: function() {
        return tilleggseiendomUtenFormuesobjekt;
    },
    harAnnetKortMedSammeFeltverdi: function() {
        return harAnnetKortMedSammeFeltverdi;
    },
    harAnnetKortMedSammeFeltverdiForOpsjon: function() {
        return harAnnetKortMedSammeFeltverdiForOpsjon;
    },
    getHeltallsDel: function() {
        return getHeltallsDel;
    },
    getDesimaltallsDel: function() {
        return getDesimaltallsDel;
    }
});
var _proptypes = /*#__PURE__*/ _interop_require_default(require("prop-types"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _flatMap = /*#__PURE__*/ _interop_require_default(require("lodash/flatMap"));
var _pickBy = /*#__PURE__*/ _interop_require_default(require("lodash/pickBy"));
var _isArray = /*#__PURE__*/ _interop_require_default(require("lodash/isArray"));
var _isempty = /*#__PURE__*/ _interop_require_default(require("../utils/is-empty"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var erSkuddAar = function(aar) {
    return aar % 4 === 0 && aar % 100 !== 0 || aar % 400 === 0;
};
var maxDagerIAar = function(verdi, inntektsaar) {
    var max = erSkuddAar(inntektsaar) ? 366 : 365;
    return !(verdi > max || verdi < 0);
};
var not = function(validator) {
    return function(verdi) {
        return !validator(verdi);
    };
};
var isUndefined = function(verdi) {
    return verdi === undefined;
};
var isNull = function(verdi) {
    return verdi === null;
};
var greaterOrEqualTo = function(min) {
    return function(verdi) {
        return isNaN(verdi) || verdi >= min;
    };
};
var lessOrEqualTo = function(max) {
    return function(verdi) {
        return isNaN(verdi) || verdi <= max;
    };
};
var firstTrue = function(predicate1, predicate2) {
    return function(verdi) {
        return predicate1(verdi) || predicate2(verdi);
    };
};
var regex = function(regexp) {
    return function(verdi) {
        return new RegExp(regexp).test(verdi);
    };
};
var undefinedOrRegex = function(regexp) {
    return firstTrue(isUndefined, regex(regexp));
};
var erHeltall = undefinedOrRegex("^$|^-?0$|^-?[1-9][0-9]*$");
var erPositivtHeltall = undefinedOrRegex("^$|^0$|^([1-9][0-9]*)?$");
var isIkkePositivtHeltall = not(erPositivtHeltall);
var erNumerisk = undefinedOrRegex("^\\d*$");
var erNumeriskNull = undefinedOrRegex("^0$");
var between = function(min, max) {
    return function(verdi) {
        return verdi >= min && verdi <= max;
    };
};
var isNumber = function(verdi) {
    return !isNaN(verdi) && !(0, _isempty.default)(verdi) && !!verdi !== verdi;
};
var greaterThanAndLessOrEqual = function(min, max) {
    return function(verdi) {
        return verdi > min && verdi <= max;
    };
};
var empty = undefinedOrRegex("^$");
var sum = function(nummer, faktorer) {
    var total = 0;
    for(var i = 0, l = faktorer.length; i < l; ++i){
        total += parseInt(nummer.charAt(i), 10) * faktorer[i];
    }
    return total;
};
var validerFnr = function(verdi) {
    var fnr = verdi.toString();
    if (!fnr || fnr.length !== 11) {
        return false;
    }
    var checksum1 = 11 - sum(fnr, [
        3,
        7,
        6,
        1,
        8,
        9,
        4,
        5,
        2
    ]) % 11;
    if (checksum1 === 11) checksum1 = 0;
    var checksum2 = 11 - sum(fnr, [
        5,
        4,
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2
    ]) % 11;
    if (checksum2 === 11) checksum2 = 0;
    return checksum1 === parseInt(fnr.charAt(9), 10) && checksum2 === parseInt(fnr.charAt(10), 10);
};
var validerOrgnr = function(verdi) {
    var orgnr = verdi.toString();
    if (!orgnr || orgnr.length !== 9) {
        return false;
    }
    var checksum1 = 11 - sum(orgnr, [
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2
    ]) % 11;
    if (checksum1 === 11) checksum1 = 0;
    return checksum1 === parseInt(orgnr.charAt(8), 10);
};
var validerMinMaksBeloep = function(args) {
    return function(verdi) {
        if (!verdi || !args) {
            return true;
        }
        var _args_min = args.min, min = _args_min === void 0 ? 0 : _args_min, maks = args.maks;
        if (maks) {
            return verdi >= parseInt(min, 10) && verdi <= parseInt(maks, 10);
        }
        return verdi >= parseInt(min, 10);
    };
};
var validerValidatorkonfig = function(validator, konfig) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    if (!validator.propTypes && !konfig.applikasjon) {
        throw new Error("Forventer propTypes " + validator);
    }
    var consoleError = console.error;
    try {
        // PropTypes kaster ikke error ved feil, ref: https://github.com/facebook/prop-types/pull/54
        console.error = function(error) {
            throw error;
        };
        _proptypes.default.resetWarningCache();
        // eslint-disable-next-line
        _proptypes.default.checkPropTypes(validator.propTypes, konfig);
    } finally{
        console.error = consoleError;
    }
};
var minErStoerreEnnMaks = function(props, propName, componentName) {
    if (typeof props[propName] !== "number") {
        return new Error("Invalid prop `".concat(propName, "` passed to `").concat(componentName, "`. Expected number."));
    }
    if (parseInt(props[propName], 10) > parseInt(props.maks, 10)) {
        return new Error("min er st\xf8rre enn maks.");
    }
    return false;
};
var TILLEGGSEIENDOM = "skalIkkeFastsettes";
var finnFormuesobjekter = function(visningsdata) {
    var entries = Object.values((0, _pickBy.default)(visningsdata, _isArray.default));
    return (0, _flatMap.default)(entries).filter(function(forekomst) {
        return forekomst.eiendomstype;
    });
};
var utenlandskeEiendommerFoer2024 = function(visningsdata) {
    return (0, _get.default)(visningsdata, "eiendommer.fastEiendom", []).filter(function(forekomst) {
        return forekomst.landkode;
    });
};
var tilleggseiendomUtenFormuesobjekt = function(visningsdata, eiendom, inntektsaar) {
    var formuesobjekter;
    if (inntektsaar <= 2023) {
        formuesobjekter = finnFormuesobjekter(visningsdata).filter(function(forekomst) {
            return !forekomst.tilhoererEiendom;
        }).filter(function(forekomst) {
            return forekomst.id !== eiendom.id;
        }).filter(function(forekomst) {
            return !utenlandskeEiendommerFoer2024(visningsdata).some(function(utenlandskEiendom) {
                return utenlandskEiendom.internEiendomsidentifikator === forekomst.internEiendomsidentifikator;
            });
        });
    } else {
        var erEiendomINorge = function(eiendom) {
            return eiendom.landkode === "NO" || !eiendom.landkode;
        };
        formuesobjekter = (0, _get.default)(visningsdata, "fastEiendom", []).filter(function(forekomst) {
            return forekomst.id !== eiendom.id;
        }).filter(erEiendomINorge).filter(function(forekomst) {
            return !!forekomst.sergEiendomsidentifikator;
        }).filter(function(forekomst) {
            return forekomst.fastEiendomSomFormuesobjekt && forekomst.fastEiendomSomFormuesobjekt.some(function(f) {
                return f.eiendomstype !== TILLEGGSEIENDOM;
            });
        });
    }
    return formuesobjekter.length < 1;
};
var harAnnetKortMedSammeFeltverdi = function(kortData, visningsdata, kortdefinisjon, feltNavn) {
    var andreKortForKorttypen = ((0, _get.default)(visningsdata, kortdefinisjon.referanse) || []).filter(function(k) {
        return k.id !== kortData.id;
    });
    if ((0, _isempty.default)(andreKortForKorttypen)) {
        return false;
    }
    if (kortData[feltNavn]) {
        return andreKortForKorttypen.some(function(k) {
            return k[feltNavn] === kortData[feltNavn];
        });
    } else {
        return andreKortForKorttypen.some(function(k) {
            return !k[feltNavn];
        });
    }
};
var harAnnetKortMedSammeFeltverdiForOpsjon = function(kortData, visningsdata, kortreferanse, feltNavn) {
    var andreKortForKorttypen = ((0, _get.default)(visningsdata, kortreferanse) || []).filter(function(k) {
        return k.id !== kortData.id;
    });
    if ((0, _isempty.default)(andreKortForKorttypen)) {
        return false;
    }
    if (kortData[feltNavn] && kortData[feltNavn] !== "ingen") {
        return andreKortForKorttypen.some(function(k) {
            return k[feltNavn] === kortData[feltNavn];
        });
    } else {
        return andreKortForKorttypen.some(function(k) {
            return !k[feltNavn] || k[feltNavn] === "ingen";
        });
    }
};
var getHeltallsDel = function(verdi) {
    if (!verdi && verdi !== 0) {
        return verdi;
    }
    var stringVerdi = "" + verdi;
    if (stringVerdi.indexOf(".") !== -1) {
        return stringVerdi.split(".")[0];
    }
    if (stringVerdi.indexOf(",") !== -1) {
        return stringVerdi.split(",")[0];
    }
    return verdi;
};
var getDesimaltallsDel = function(verdi) {
    var stringVerdi = "" + verdi;
    if (stringVerdi.indexOf(".") !== -1) {
        return stringVerdi.split(".")[1];
    }
    if (stringVerdi.indexOf(",") !== -1) {
        return stringVerdi.split(",")[1];
    }
    return undefined;
};
